require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-myingyan-gas-power-plant.json") })
        }
      }, "path---en-us-project-myingyan-gas-power-plant");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-myingyan-gas-power-plant!./.cache/json/en-us-project-myingyan-gas-power-plant.json
// module id = 546
// module chunks = 231608221292675